import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { initTheme } from './lib/theme'

// BEFORE REACT MOUNTS, so the first paint is in the right theme rather than
// flashing light and correcting itself. The theme is a class on <html> because
// shadcn's dark tokens live behind `.dark` rather than a media query, and
// something has to put it there.
initTheme()

// StrictMode is on, which double-invokes every effect in development. That is
// kept deliberately: every fetch in this app is guarded by an AbortController for
// exactly that reason, and the double invocation is what proves the guard works
// before a slow network does it in front of somebody.
const el = document.getElementById('root')
if (!el) throw new Error('#root missing from index.html')
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
